import { QuerySwitch } from 'components/QuerySwitch';
import { ShiftSwapLocationSettingsPageForm } from 'pages/LocationSettingsPage/ShiftSwapLocationSettingsPageForm';
import {
  LocationRecordDetailDataContext,
  LocationRecordDetailDataProvider,
} from 'pages/LocationSettingsPage/LocationRecordDetail.data.context';
import { FC } from 'react';

export const ShiftSwapLocationSettingsPage: FC = () => {
  return (
    <LocationRecordDetailDataProvider>
      <QuerySwitch
        context={LocationRecordDetailDataContext}
        component={ShiftSwapLocationSettingsPageForm}
      />
    </LocationRecordDetailDataProvider>
  );
};
